var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useNavigate } from 'react-router-dom';
function StepSuccess() {
    var navigate = useNavigate();
    var handleLoginClick = function () {
        navigate('/login');
    };
    return (_jsxs("div", __assign({ className: "box-welcome" }, { children: [_jsx("h2", { children: "Acesso liberado!" }), _jsx("h2", { children: "Tudo pronto para come\u00E7ar." }), _jsx("p", { children: "Bem-vindo(a) oficialmente \u00E0 CeletiHub! Explore, conecte-se e aproveite todos os recursos do portal." }), _jsxs("p", { children: ["Ao entrar, voc\u00EA concorda com nossos", ' ', _jsx("a", __assign({ href: "https://www.celeti.com.br/politicas-de-privacidade", style: { color: '#fff', textDecoration: 'underline' } }, { children: "Termos de Uso." }))] }), _jsx("div", __assign({ className: "box-first-access-button", onClick: handleLoginClick }, { children: _jsx("button", __assign({ type: "submit", className: "btn-first-access" }, { children: "Entrar agora" })) }))] })));
}
export default StepSuccess;
